import { getEntries } from "./objectUtils";

const cremNorm = getEntries({
  "Voor 2023": Infinity,
  "2023": 25.96,
  "2024": 24.83,
  "2025": 23.73,
  "2026": 22.65,
  "2027": 21.59,
  "2028": 20.56,
  "2029": 19.55,
  "2030": 18.57,
  "2031": 17.61,
  "2032": 16.68,
  "2033": 15.76,
  "2034": 14.85,
  "2035": 13.94,
  "2036": 13.03,
  "2037": 12.1,
  "2038": 11.16,
  "2039": 10.2,
  "2040": 9.23,
  "2041": 8.25,
  "2042": 7.28,
  "2043": 6.33,
  "2044": 5.42,
  "2045": 4.57,
  "2046": 3.79,
  "2047": 3.1,
  "2048": 2.49,
  "2049": 1.99,
  "Na 2050": 1.59,
}).sort(([,a], [,b]) => a - b);

export function getCremNormYear(emissionPerM2: number | undefined) {
  return cremNorm.find(([_, cremValue]) => cremValue >= (emissionPerM2 ?? Infinity))?.[0] ?? "Voor 2023";
}
